// extracted by mini-css-extract-plugin
module.exports = {"animationWrapper":"rivermax_animationWrapper__h9v1W"};